import './_product-description.scss';
import component from './product-description';

export default component;
